import { jsxs as c, jsx as u, Fragment as Lr } from "react/jsx-runtime";
import { forwardRef as Nr } from "react";
function Pr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var X = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var rr;
function Dr() {
  return rr || (rr = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function a() {
        for (var r = "", t = 0; t < arguments.length; t++) {
          var i = arguments[t];
          i && (r = p(r, o.call(this, i)));
        }
        return r;
      }
      function o(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return a.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var t = "";
        for (var i in r)
          n.call(r, i) && r[i] && (t = p(t, this && this[i] || i));
        return t;
      }
      function p(r, t) {
        return t ? r ? r + " " + t : r + t : r;
      }
      e.exports ? (a.default = a, e.exports = a) : window.classNames = a;
    })();
  }(X)), X.exports;
}
var Hr = Dr();
const Tr = /* @__PURE__ */ Pr(Hr), Vr = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, Wr = Tr.bind(Vr), er = "purpur-icon", Kr = "md", Yr = (e) => e.filter((n) => Object.keys(n).length >= 1).map((n) => `${n.name}="${n.value}"`).join(" "), Jr = ({ content: e = "", title: n } = {}) => {
  const a = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    n ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], o = n ? `<title>${n}</title>` : "";
  return `<svg ${Yr(a)}>${o}${e}</svg>`;
}, Qr = (e) => e.replace(/<(\/?)svg([^>]*)>/g, "").trim(), jr = ({
  ["data-testid"]: e,
  svg: n,
  allyTitle: a,
  className: o,
  size: p = Kr,
  ...r
}) => {
  const t = Jr({
    content: Qr(n.svg),
    title: a
  }), i = Wr(o, er, `${er}--${p}`);
  return /* @__PURE__ */ u(
    "span",
    {
      className: i,
      "data-testid": e,
      dangerouslySetInnerHTML: { __html: t },
      ...r
    }
  );
};
jr.displayName = "Icon";
const Xr = {
  name: "alert",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="m13.038 7.067-.247 6.876h-1.566l-.247-6.876a1.03 1.03 0 1 1 2.06 0Zm.212 8.917c0 .649-.586 1.234-1.25 1.234-.649 0-1.25-.585-1.25-1.234 0-.633.601-1.234 1.25-1.234.664 0 1.25.601 1.25 1.234Z"/><path fill-rule="evenodd" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-1.75 0a8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 16.5 0Z" clip-rule="evenodd"/></svg>',
  keywords: ["alert"],
  category: "status"
}, re = {
  name: "check-circle",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M16.487 9.514a.872.872 0 1 0-1.42-1.014l-4.248 5.948-2.18-2.18a.872.872 0 0 0-1.233 1.234l2.908 2.908a.872.872 0 0 0 1.326-.11l4.847-6.786Z"/><path fill-rule="evenodd" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-1.75 0a8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 16.5 0Z" clip-rule="evenodd"/></svg>',
  keywords: ["check-circle"],
  category: "status"
}, ee = {
  name: "devices",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M10 3.4a.1.1 0 0 0-.1.1V4a.9.9 0 0 1-1.8 0v-.5c0-1.05.85-1.9 1.9-1.9h10c1.05 0 1.9.85 1.9 1.9v15a1.9 1.9 0 0 1-1.9 1.9h-6a.9.9 0 1 1 0-1.8h6a.1.1 0 0 0 .1-.1v-15a.1.1 0 0 0-.1-.1H10ZM2.1 8c0-1.05.85-1.9 1.9-1.9h6c1.05 0 1.9.85 1.9 1.9v12a1.9 1.9 0 0 1-1.9 1.9H4A1.9 1.9 0 0 1 2.1 20V8ZM4 7.9a.1.1 0 0 0-.1.1v12a.1.1 0 0 0 .1.1h6a.1.1 0 0 0 .1-.1V8a.1.1 0 0 0-.1-.1H4ZM14.6 17a.9.9 0 0 1 .9-.9h.5a.9.9 0 1 1 0 1.8h-.5a.9.9 0 0 1-.9-.9Zm-8.5 1.5a.9.9 0 0 1 .9-.9h.5a.9.9 0 1 1 0 1.8H7a.9.9 0 0 1-.9-.9Z" clip-rule="evenodd"/></svg>',
  keywords: ["devices"],
  category: "device"
}, te = {
  name: "error",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M10.354 3.05c.732-1.267 2.56-1.267 3.291 0l8.66 15c.732 1.267-.182 2.85-1.645 2.85H3.34c-1.463 0-2.377-1.583-1.646-2.85l8.66-15Zm1.595.862a.092.092 0 0 0-.036.038l-8.66 15a.092.092 0 0 0-.015.05c0 .014.005.032.015.05a.11.11 0 0 0 .036.038.09.09 0 0 0 .05.012H20.66a.088.088 0 0 0 .05-.012.106.106 0 0 0 .037-.038.105.105 0 0 0 .015-.05.092.092 0 0 0-.015-.05l-8.66-15a.092.092 0 0 0-.036-.038A.106.106 0 0 0 12 3.9a.105.105 0 0 0-.05.012Z" clip-rule="evenodd"/><path d="m12.523 14.922.412-6.25a.936.936 0 1 0-1.868 0l.421 6.25h1.035ZM12 17.52c.44 0 .826-.387.826-.815 0-.418-.387-.816-.826-.816-.428 0-.825.398-.825.816 0 .428.397.815.825.815Z"/><path fill-rule="evenodd" d="M12.691 15.096h-1.37l-.431-6.53a1 1 0 0 1 .997-1.066h.227a1 1 0 0 1 .998 1.064l-.42 6.532Zm.244-6.425a.936.936 0 1 0-1.868.002l.421 6.249h1.035l.412-6.25ZM13 16.706c0 .526-.466.99-1 .99-.522 0-1-.463-1-.99 0-.264.125-.51.304-.689.18-.178.429-.301.696-.301.536 0 1 .475 1 .99Zm-.174 0c0 .428-.387.815-.826.815-.428 0-.825-.387-.825-.815 0-.418.397-.816.825-.816.44 0 .826.398.826.816Z" clip-rule="evenodd"/></svg>',
  keywords: ["error"],
  category: "status"
}, ae = {
  name: "info",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M11 8.18c0 .537.469.979 1.007.979.524 0 .993-.442.993-.98s-.469-.979-.993-.979c-.538 0-1.007.441-1.007.98Zm.152 1.958v6.897h1.696v-6.897h-1.696Z"/><path fill-rule="evenodd" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-1.75 0a8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 16.5 0Z" clip-rule="evenodd"/></svg>',
  keywords: ["info"],
  category: "status"
}, ie = {
  name: "offering",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M7.118 4.6H7a1.9 1.9 0 0 0-1.9 1.9V8a1.9 1.9 0 0 0 1.5 1.858v.642a.9.9 0 1 0 1.8 0v-.6h3.2v.6a.9.9 0 0 0 1.8 0v-.6h3.7V11a.9.9 0 0 0 1.8 0V9.858A1.9 1.9 0 0 0 20.4 8V6.5a1.9 1.9 0 0 0-1.9-1.9h-.618c-.063-.708-.3-1.394-.756-1.943-.56-.674-1.384-1.057-2.376-1.057-.92 0-1.696.33-2.25.915-.554-.585-1.33-.915-2.25-.915-.992 0-1.816.383-2.376 1.057-.457.549-.693 1.235-.756 1.943Zm1.812 0h2.64c-.053-.34-.174-.607-.328-.792-.192-.232-.493-.408-.992-.408s-.8.176-.992.408c-.154.185-.275.452-.328.792Zm4.5 0h2.64c-.053-.34-.174-.607-.328-.792-.192-.232-.493-.408-.992-.408s-.8.176-.992.408c-.154.185-.275.452-.328.792Zm-.03 3.5h5.1a.1.1 0 0 0 .1-.1V6.5a.1.1 0 0 0-.1-.1h-5.1v1.7Zm-1.8-1.7H7a.1.1 0 0 0-.1.1V8a.1.1 0 0 0 .1.1h4.6V6.4Zm8.335 5.147c.743-.107 1.52.135 2.201.817.474.473.695 1.011.708 1.548.012.508-.163.927-.318 1.2-.185.326-.47.607-.634.77l-.049.047-4.414 4.414a1.9 1.9 0 0 1-1.343.557H7.914a.1.1 0 0 0-.07.03l-.5.5a1.9 1.9 0 0 1-2.687 0L2.57 19.342a1.9 1.9 0 0 1 0-2.686l4-4a1.9 1.9 0 0 1 1.343-.557H14.5v.9-.9h.041l.065.004a2.73 2.73 0 0 1 .79.185 2.665 2.665 0 0 1 1.46 1.417c.188-.162.375-.324.551-.479.46-.401.815-.722.957-.863.338-.34.882-.719 1.571-.817ZM15.088 15.1a1.06 1.06 0 0 0 .08-.145c.1-.207.113-.38.027-.553a.867.867 0 0 0-.668-.497.628.628 0 0 0-.042-.005h-6.57a.1.1 0 0 0-.071.03l-4 4a.1.1 0 0 0 0 .14l2.085 2.087a.1.1 0 0 0 .142 0l.5-.5a1.9 1.9 0 0 1 1.343-.557h8.172a.1.1 0 0 0 .07-.03l4.415-4.414c.225-.225.334-.335.39-.434a.539.539 0 0 0 .083-.266.283.283 0 0 0-.026-.11.712.712 0 0 0-.154-.21c-.319-.318-.542-.326-.674-.307-.186.026-.392.146-.554.307-.191.192-.595.553-1.043.946-.904.79-2.143 1.838-2.561 2.144l-.238.174H10.5a.9.9 0 0 1 0-1.8h4.588Z" clip-rule="evenodd"/></svg>',
  keywords: ["offering"],
  category: "other"
}, ne = {
  name: "question",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M13.672 12.056c-.635.547-1.242 1.07-1.164 2.062h-1.385c-.309-1.553.504-2.214 1.23-2.805.514-.419.986-.802.986-1.442 0-.593-.489-1.068-1.267-1.068-.764 0-1.345.422-1.872 1.187L9 9.067C9.712 7.92 10.807 7.3 12.086 7.3 13.906 7.3 15 8.42 15 9.78c0 1.133-.678 1.717-1.328 2.277Zm-.822 3.763c0 .54-.487 1.028-1.041 1.028-.554 0-1.042-.488-1.042-1.028 0-.528.488-1.029 1.042-1.029s1.042.501 1.042 1.029Z"/><path fill-rule="evenodd" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-1.75 0a8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 16.5 0Z" clip-rule="evenodd"/></svg>',
  keywords: ["question"],
  category: "status"
}, oe = {
  name: "tag",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M3.1 4a.9.9 0 0 1 .9-.9h6.5a.9.9 0 0 1 .636.264l10 10a.9.9 0 0 1 0 1.272l-4.5 4.5a.9.9 0 1 1-1.272-1.272L19.227 14l-9.1-9.1H4.9v5.227l9.736 9.737a.9.9 0 1 1-1.272 1.272l-10-10A.9.9 0 0 1 3.1 10.5V4ZM8 7.4a.6.6 0 1 0 0 1.2.6.6 0 0 0 0-1.2ZM5.6 8a2.4 2.4 0 1 1 4.8 0 2.4 2.4 0 0 1-4.8 0Z" clip-rule="evenodd"/></svg>',
  keywords: ["tag"],
  category: "other"
};
function pe(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var tr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var ar;
function ue() {
  return ar || (ar = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function a() {
        for (var r = "", t = 0; t < arguments.length; t++) {
          var i = arguments[t];
          i && (r = p(r, o(i)));
        }
        return r;
      }
      function o(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return a.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var t = "";
        for (var i in r)
          n.call(r, i) && r[i] && (t = p(t, i));
        return t;
      }
      function p(r, t) {
        return t ? r ? r + " " + t : r + t : r;
      }
      e.exports ? (a.default = a, e.exports = a) : window.classNames = a;
    })();
  }(tr)), tr.exports;
}
var le = ue();
const ir = /* @__PURE__ */ pe(le), P = {
  "purpur-badge": "_purpur-badge_1mlzj_1",
  "purpur-badge__icon": "_purpur-badge__icon_1mlzj_13",
  "purpur-badge--attention": "_purpur-badge--attention_1mlzj_17",
  "purpur-badge--special": "_purpur-badge--special_1mlzj_21",
  "purpur-badge--neutral": "_purpur-badge--neutral_1mlzj_25",
  "purpur-badge--general": "_purpur-badge--general_1mlzj_29",
  "purpur-badge--information": "_purpur-badge--information_1mlzj_33",
  "purpur-badge--success": "_purpur-badge--success_1mlzj_37",
  "purpur-badge--warning": "_purpur-badge--warning_1mlzj_41",
  "purpur-badge--error": "_purpur-badge--error_1mlzj_45",
  "purpur-badge--black-friday": "_purpur-badge--black-friday_1mlzj_49"
}, D = "purpur-badge", g = {
  ATTENTION: "attention",
  BLACK_FRIDAY: "black-friday",
  ERROR: "error",
  GENERAL: "general",
  INFORMATION: "information",
  NEUTRAL: "neutral",
  SPECIAL: "special",
  SUCCESS: "success",
  WARNING: "warning"
}, se = (e) => {
  switch (e) {
    case g.ATTENTION:
    case g.SPECIAL:
      return ie;
    case g.INFORMATION:
      return ae;
    case g.GENERAL:
      return ee;
    case g.SUCCESS:
      return re;
    case g.WARNING:
      return Xr;
    case g.ERROR:
      return te;
    case g.NEUTRAL:
      return ne;
    case g.BLACK_FRIDAY:
      return oe;
    default:
      return;
  }
}, de = ({
  children: e,
  showIcon: n = !0,
  iconAllyTitle: a,
  variant: o,
  ["data-testid"]: p,
  className: r = "",
  ...t
}) => {
  const i = se(o), l = ir([r, P[D], P[`${D}--${o}`]]);
  return /* @__PURE__ */ c("span", { className: l, "data-testid": p, ...t, children: [
    n && i && /* @__PURE__ */ u(
      jr,
      {
        "data-testid": `${p}-icon`,
        allyTitle: a,
        size: "xs",
        svg: i,
        className: ir(P[`${D}__icon`])
      }
    ),
    e
  ] });
};
function ce(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var nr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var or;
function _e() {
  return or || (or = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function a() {
        for (var r = "", t = 0; t < arguments.length; t++) {
          var i = arguments[t];
          i && (r = p(r, o.call(this, i)));
        }
        return r;
      }
      function o(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return a.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var t = "";
        for (var i in r)
          n.call(r, i) && r[i] && (t = p(t, this && this[i] || i));
        return t;
      }
      function p(r, t) {
        return t ? r ? r + " " + t : r + t : r;
      }
      e.exports ? (a.default = a, e.exports = a) : window.classNames = a;
    })();
  }(nr)), nr.exports;
}
var fe = _e();
const _ = /* @__PURE__ */ ce(fe), he = {
  "purpur-card__container": "_purpur-card__container_fwz6v_1",
  "purpur-card__container--full-height": "_purpur-card__container--full-height_fwz6v_4",
  "purpur-card": "_purpur-card_fwz6v_1"
};
function ge(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var pr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var ur;
function me() {
  return ur || (ur = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function a() {
        for (var r = "", t = 0; t < arguments.length; t++) {
          var i = arguments[t];
          i && (r = p(r, o.call(this, i)));
        }
        return r;
      }
      function o(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return a.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var t = "";
        for (var i in r)
          n.call(r, i) && r[i] && (t = p(t, this && this[i] || i));
        return t;
      }
      function p(r, t) {
        return t ? r ? r + " " + t : r + t : r;
      }
      e.exports ? (a.default = a, e.exports = a) : window.classNames = a;
    })();
  }(pr)), pr.exports;
}
var ve = me();
const ye = /* @__PURE__ */ ge(ve), we = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, xe = ye.bind(we), lr = "purpur-icon", be = "md", Ce = (e) => e.filter((n) => Object.keys(n).length >= 1).map((n) => `${n.name}="${n.value}"`).join(" "), Se = ({ content: e = "", title: n } = {}) => {
  const a = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    n ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], o = n ? `<title>${n}</title>` : "";
  return `<svg ${Ce(a)}>${o}${e}</svg>`;
}, $e = (e) => e.replace(/<(\/?)svg([^>]*)>/g, "").trim(), Mr = ({
  ["data-testid"]: e,
  svg: n,
  allyTitle: a,
  className: o,
  size: p = be,
  ...r
}) => {
  const t = Se({
    content: $e(n.svg),
    title: a
  }), i = xe(o, lr, `${lr}--${p}`);
  return /* @__PURE__ */ u(
    "span",
    {
      className: i,
      "data-testid": e,
      dangerouslySetInnerHTML: { __html: t },
      ...r
    }
  );
};
Mr.displayName = "Icon";
const Ae = {
  name: "alert",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="m13.038 7.067-.247 6.876h-1.566l-.247-6.876a1.03 1.03 0 1 1 2.06 0Zm.212 8.917c0 .649-.586 1.234-1.25 1.234-.649 0-1.25-.585-1.25-1.234 0-.633.601-1.234 1.25-1.234.664 0 1.25.601 1.25 1.234Z"/><path fill-rule="evenodd" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-1.75 0a8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 16.5 0Z" clip-rule="evenodd"/></svg>',
  keywords: ["alert"],
  category: "status"
}, Fe = {
  name: "check-circle",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M16.487 9.514a.872.872 0 1 0-1.42-1.014l-4.248 5.948-2.18-2.18a.872.872 0 0 0-1.233 1.234l2.908 2.908a.872.872 0 0 0 1.326-.11l4.847-6.786Z"/><path fill-rule="evenodd" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-1.75 0a8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 16.5 0Z" clip-rule="evenodd"/></svg>',
  keywords: ["check-circle"],
  category: "status"
}, Be = {
  name: "devices",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M10 3.4a.1.1 0 0 0-.1.1V4a.9.9 0 0 1-1.8 0v-.5c0-1.05.85-1.9 1.9-1.9h10c1.05 0 1.9.85 1.9 1.9v15a1.9 1.9 0 0 1-1.9 1.9h-6a.9.9 0 1 1 0-1.8h6a.1.1 0 0 0 .1-.1v-15a.1.1 0 0 0-.1-.1H10ZM2.1 8c0-1.05.85-1.9 1.9-1.9h6c1.05 0 1.9.85 1.9 1.9v12a1.9 1.9 0 0 1-1.9 1.9H4A1.9 1.9 0 0 1 2.1 20V8ZM4 7.9a.1.1 0 0 0-.1.1v12a.1.1 0 0 0 .1.1h6a.1.1 0 0 0 .1-.1V8a.1.1 0 0 0-.1-.1H4ZM14.6 17a.9.9 0 0 1 .9-.9h.5a.9.9 0 1 1 0 1.8h-.5a.9.9 0 0 1-.9-.9Zm-8.5 1.5a.9.9 0 0 1 .9-.9h.5a.9.9 0 1 1 0 1.8H7a.9.9 0 0 1-.9-.9Z" clip-rule="evenodd"/></svg>',
  keywords: ["devices"],
  category: "device"
}, ke = {
  name: "error",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M10.354 3.05c.732-1.267 2.56-1.267 3.291 0l8.66 15c.732 1.267-.182 2.85-1.645 2.85H3.34c-1.463 0-2.377-1.583-1.646-2.85l8.66-15Zm1.595.862a.092.092 0 0 0-.036.038l-8.66 15a.092.092 0 0 0-.015.05c0 .014.005.032.015.05a.11.11 0 0 0 .036.038.09.09 0 0 0 .05.012H20.66a.088.088 0 0 0 .05-.012.106.106 0 0 0 .037-.038.105.105 0 0 0 .015-.05.092.092 0 0 0-.015-.05l-8.66-15a.092.092 0 0 0-.036-.038A.106.106 0 0 0 12 3.9a.105.105 0 0 0-.05.012Z" clip-rule="evenodd"/><path d="m12.523 14.922.412-6.25a.936.936 0 1 0-1.868 0l.421 6.25h1.035ZM12 17.52c.44 0 .826-.387.826-.815 0-.418-.387-.816-.826-.816-.428 0-.825.398-.825.816 0 .428.397.815.825.815Z"/><path fill-rule="evenodd" d="M12.691 15.096h-1.37l-.431-6.53a1 1 0 0 1 .997-1.066h.227a1 1 0 0 1 .998 1.064l-.42 6.532Zm.244-6.425a.936.936 0 1 0-1.868.002l.421 6.249h1.035l.412-6.25ZM13 16.706c0 .526-.466.99-1 .99-.522 0-1-.463-1-.99 0-.264.125-.51.304-.689.18-.178.429-.301.696-.301.536 0 1 .475 1 .99Zm-.174 0c0 .428-.387.815-.826.815-.428 0-.825-.387-.825-.815 0-.418.397-.816.825-.816.44 0 .826.398.826.816Z" clip-rule="evenodd"/></svg>',
  keywords: ["error"],
  category: "status"
}, Oe = {
  name: "info",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M11 8.18c0 .537.469.979 1.007.979.524 0 .993-.442.993-.98s-.469-.979-.993-.979c-.538 0-1.007.441-1.007.98Zm.152 1.958v6.897h1.696v-6.897h-1.696Z"/><path fill-rule="evenodd" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-1.75 0a8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 16.5 0Z" clip-rule="evenodd"/></svg>',
  keywords: ["info"],
  category: "status"
}, Ne = {
  name: "offering",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M7.118 4.6H7a1.9 1.9 0 0 0-1.9 1.9V8a1.9 1.9 0 0 0 1.5 1.858v.642a.9.9 0 1 0 1.8 0v-.6h3.2v.6a.9.9 0 0 0 1.8 0v-.6h3.7V11a.9.9 0 0 0 1.8 0V9.858A1.9 1.9 0 0 0 20.4 8V6.5a1.9 1.9 0 0 0-1.9-1.9h-.618c-.063-.708-.3-1.394-.756-1.943-.56-.674-1.384-1.057-2.376-1.057-.92 0-1.696.33-2.25.915-.554-.585-1.33-.915-2.25-.915-.992 0-1.816.383-2.376 1.057-.457.549-.693 1.235-.756 1.943Zm1.812 0h2.64c-.053-.34-.174-.607-.328-.792-.192-.232-.493-.408-.992-.408s-.8.176-.992.408c-.154.185-.275.452-.328.792Zm4.5 0h2.64c-.053-.34-.174-.607-.328-.792-.192-.232-.493-.408-.992-.408s-.8.176-.992.408c-.154.185-.275.452-.328.792Zm-.03 3.5h5.1a.1.1 0 0 0 .1-.1V6.5a.1.1 0 0 0-.1-.1h-5.1v1.7Zm-1.8-1.7H7a.1.1 0 0 0-.1.1V8a.1.1 0 0 0 .1.1h4.6V6.4Zm8.335 5.147c.743-.107 1.52.135 2.201.817.474.473.695 1.011.708 1.548.012.508-.163.927-.318 1.2-.185.326-.47.607-.634.77l-.049.047-4.414 4.414a1.9 1.9 0 0 1-1.343.557H7.914a.1.1 0 0 0-.07.03l-.5.5a1.9 1.9 0 0 1-2.687 0L2.57 19.342a1.9 1.9 0 0 1 0-2.686l4-4a1.9 1.9 0 0 1 1.343-.557H14.5v.9-.9h.041l.065.004a2.73 2.73 0 0 1 .79.185 2.665 2.665 0 0 1 1.46 1.417c.188-.162.375-.324.551-.479.46-.401.815-.722.957-.863.338-.34.882-.719 1.571-.817ZM15.088 15.1a1.06 1.06 0 0 0 .08-.145c.1-.207.113-.38.027-.553a.867.867 0 0 0-.668-.497.628.628 0 0 0-.042-.005h-6.57a.1.1 0 0 0-.071.03l-4 4a.1.1 0 0 0 0 .14l2.085 2.087a.1.1 0 0 0 .142 0l.5-.5a1.9 1.9 0 0 1 1.343-.557h8.172a.1.1 0 0 0 .07-.03l4.415-4.414c.225-.225.334-.335.39-.434a.539.539 0 0 0 .083-.266.283.283 0 0 0-.026-.11.712.712 0 0 0-.154-.21c-.319-.318-.542-.326-.674-.307-.186.026-.392.146-.554.307-.191.192-.595.553-1.043.946-.904.79-2.143 1.838-2.561 2.144l-.238.174H10.5a.9.9 0 0 1 0-1.8h4.588Z" clip-rule="evenodd"/></svg>',
  keywords: ["offering"],
  category: "other"
}, je = {
  name: "question",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M13.672 12.056c-.635.547-1.242 1.07-1.164 2.062h-1.385c-.309-1.553.504-2.214 1.23-2.805.514-.419.986-.802.986-1.442 0-.593-.489-1.068-1.267-1.068-.764 0-1.345.422-1.872 1.187L9 9.067C9.712 7.92 10.807 7.3 12.086 7.3 13.906 7.3 15 8.42 15 9.78c0 1.133-.678 1.717-1.328 2.277Zm-.822 3.763c0 .54-.487 1.028-1.041 1.028-.554 0-1.042-.488-1.042-1.028 0-.528.488-1.029 1.042-1.029s1.042.501 1.042 1.029Z"/><path fill-rule="evenodd" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-1.75 0a8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 16.5 0Z" clip-rule="evenodd"/></svg>',
  keywords: ["question"],
  category: "status"
}, Me = {
  name: "tag",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M3.1 4a.9.9 0 0 1 .9-.9h6.5a.9.9 0 0 1 .636.264l10 10a.9.9 0 0 1 0 1.272l-4.5 4.5a.9.9 0 1 1-1.272-1.272L19.227 14l-9.1-9.1H4.9v5.227l9.736 9.737a.9.9 0 1 1-1.272 1.272l-10-10A.9.9 0 0 1 3.1 10.5V4ZM8 7.4a.6.6 0 1 0 0 1.2.6.6 0 0 0 0-1.2ZM5.6 8a2.4 2.4 0 1 1 4.8 0 2.4 2.4 0 0 1-4.8 0Z" clip-rule="evenodd"/></svg>',
  keywords: ["tag"],
  category: "other"
};
function Ge(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var sr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var dr;
function Ze() {
  return dr || (dr = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function a() {
        for (var r = "", t = 0; t < arguments.length; t++) {
          var i = arguments[t];
          i && (r = p(r, o(i)));
        }
        return r;
      }
      function o(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return a.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var t = "";
        for (var i in r)
          n.call(r, i) && r[i] && (t = p(t, i));
        return t;
      }
      function p(r, t) {
        return t ? r ? r + " " + t : r + t : r;
      }
      e.exports ? (a.default = a, e.exports = a) : window.classNames = a;
    })();
  }(sr)), sr.exports;
}
var Ee = Ze();
const cr = /* @__PURE__ */ Ge(Ee), H = {
  "purpur-badge": "_purpur-badge_1mlzj_1",
  "purpur-badge__icon": "_purpur-badge__icon_1mlzj_13",
  "purpur-badge--attention": "_purpur-badge--attention_1mlzj_17",
  "purpur-badge--special": "_purpur-badge--special_1mlzj_21",
  "purpur-badge--neutral": "_purpur-badge--neutral_1mlzj_25",
  "purpur-badge--general": "_purpur-badge--general_1mlzj_29",
  "purpur-badge--information": "_purpur-badge--information_1mlzj_33",
  "purpur-badge--success": "_purpur-badge--success_1mlzj_37",
  "purpur-badge--warning": "_purpur-badge--warning_1mlzj_41",
  "purpur-badge--error": "_purpur-badge--error_1mlzj_45",
  "purpur-badge--black-friday": "_purpur-badge--black-friday_1mlzj_49"
}, T = "purpur-badge", m = {
  ATTENTION: "attention",
  BLACK_FRIDAY: "black-friday",
  ERROR: "error",
  GENERAL: "general",
  INFORMATION: "information",
  NEUTRAL: "neutral",
  SPECIAL: "special",
  SUCCESS: "success",
  WARNING: "warning"
}, Ue = (e) => {
  switch (e) {
    case m.ATTENTION:
    case m.SPECIAL:
      return Ne;
    case m.INFORMATION:
      return Oe;
    case m.GENERAL:
      return Be;
    case m.SUCCESS:
      return Fe;
    case m.WARNING:
      return Ae;
    case m.ERROR:
      return ke;
    case m.NEUTRAL:
      return je;
    case m.BLACK_FRIDAY:
      return Me;
    default:
      return;
  }
}, ze = ({
  children: e,
  showIcon: n = !0,
  iconAllyTitle: a,
  variant: o,
  ["data-testid"]: p,
  className: r = "",
  ...t
}) => {
  const i = Ue(o), l = cr([r, H[T], H[`${T}--${o}`]]);
  return /* @__PURE__ */ c("span", { className: l, "data-testid": p, ...t, children: [
    n && i && /* @__PURE__ */ u(
      Mr,
      {
        "data-testid": `${p}-icon`,
        allyTitle: a,
        size: "xs",
        svg: i,
        className: cr(H[`${T}__icon`])
      }
    ),
    e
  ] });
}, Ie = {
  "purpur-card-badge": "_purpur-card-badge_k9ziu_1"
}, qe = _.bind(Ie), Re = "purpur-card-badge", Le = ({
  ["data-testid"]: e = "purpur-card-badge",
  variant: n,
  text: a
}) => n && a ? /* @__PURE__ */ u(
  ze,
  {
    className: qe(Re),
    variant: n,
    showIcon: !1,
    "data-testid": e,
    children: a
  }
) : null, Pe = {
  "purpur-card-content": "_purpur-card-content_2uc00_1"
}, De = _.bind(Pe), He = "purpur-card-content", Te = ({
  ["data-testid"]: e = "purpur-card-content",
  children: n
}) => /* @__PURE__ */ u("div", { className: De(He), "data-testid": e, children: n }), Ve = {
  "purpur-card-content-container": "_purpur-card-content-container_putaw_1",
  "purpur-card-content-container--footer": "_purpur-card-content-container--footer_putaw_12",
  "purpur-card-content-container--gap-size--sm": "_purpur-card-content-container--gap-size--sm_putaw_20",
  "purpur-card-content-container--gap-size--md": "_purpur-card-content-container--gap-size--md_putaw_23",
  "purpur-card-content-container--gap-size--lg": "_purpur-card-content-container--gap-size--lg_putaw_26"
}, We = _.bind(Ve), V = "purpur-card-content-container", Ke = ({
  ["data-testid"]: e = "purpur-card-content-container",
  children: n,
  className: a,
  isFooter: o = !1,
  gapSize: p = "md",
  ...r
}) => /* @__PURE__ */ u(
  "div",
  {
    className: We([
      V,
      a,
      `${V}--gap-size--${p}`,
      {
        [`${V}--footer`]: o
      }
    ]),
    "data-testid": e,
    ...r,
    children: n
  }
);
function Ye(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var _r = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var fr;
function Je() {
  return fr || (fr = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function a() {
        for (var r = "", t = 0; t < arguments.length; t++) {
          var i = arguments[t];
          i && (r = p(r, o(i)));
        }
        return r;
      }
      function o(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return a.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var t = "";
        for (var i in r)
          n.call(r, i) && r[i] && (t = p(t, i));
        return t;
      }
      function p(r, t) {
        return t ? r ? r + " " + t : r + t : r;
      }
      e.exports ? (a.default = a, e.exports = a) : window.classNames = a;
    })();
  }(_r)), _r.exports;
}
var Qe = Je();
const hr = /* @__PURE__ */ Ye(Qe), Xe = "_rotate_1xozj_1", rt = "_dash_1xozj_1", $ = {
  "purpur-spinner": "_purpur-spinner_1xozj_1",
  rotate: Xe,
  "purpur-spinner--xxs": "_purpur-spinner--xxs_1xozj_4",
  "purpur-spinner--xs": "_purpur-spinner--xs_1xozj_8",
  "purpur-spinner--sm": "_purpur-spinner--sm_1xozj_12",
  "purpur-spinner--md": "_purpur-spinner--md_1xozj_16",
  "purpur-spinner--lg": "_purpur-spinner--lg_1xozj_20",
  "purpur-spinner__circle": "_purpur-spinner__circle_1xozj_24",
  dash: rt,
  "purpur-spinner__circle--disabled": "_purpur-spinner__circle--disabled_1xozj_33",
  "purpur-spinner__circle--negative": "_purpur-spinner__circle--negative_1xozj_36"
}, A = "purpur-spinner", et = {
  SM: "sm"
}, tt = ({
  ["data-testid"]: e,
  disabled: n = !1,
  negative: a = !1,
  size: o = et.SM,
  ...p
}) => /* @__PURE__ */ u(
  "div",
  {
    className: hr([$[A], $[`${A}--${o}`]]),
    "data-testid": e,
    ...p,
    children: /* @__PURE__ */ u("svg", { viewBox: "0 0 50 50", children: /* @__PURE__ */ u(
      "circle",
      {
        className: hr($[`${A}__circle`], {
          [$[`${A}__circle--disabled`]]: n,
          [$[`${A}__circle--negative`]]: a
        }),
        cx: "25",
        cy: "25",
        r: "20"
      }
    ) })
  }
), at = {
  "purpur-card-cta--button-styling": "_purpur-card-cta--button-styling_1wc0z_1",
  "purpur-card-cta--button-styling--xs": "_purpur-card-cta--button-styling--xs_1wc0z_33",
  "purpur-card-cta--button-styling--icon-only": "_purpur-card-cta--button-styling--icon-only_1wc0z_36",
  "purpur-card-cta--button-styling--sm": "_purpur-card-cta--button-styling--sm_1wc0z_39",
  "purpur-card-cta--button-styling--md": "_purpur-card-cta--button-styling--md_1wc0z_45",
  "purpur-card-cta--button-styling--lg": "_purpur-card-cta--button-styling--lg_1wc0z_51",
  "purpur-card-cta--button-styling--full-width": "_purpur-card-cta--button-styling--full-width_1wc0z_57",
  "purpur-card-cta--button-styling--primary": "_purpur-card-cta--button-styling--primary_1wc0z_60",
  "purpur-card-cta--button-styling--disabled": "_purpur-card-cta--button-styling--disabled_1wc0z_64",
  "purpur-card-cta--button-styling--primary-negative": "_purpur-card-cta--button-styling--primary-negative_1wc0z_70",
  "purpur-card-cta--button-styling--secondary": "_purpur-card-cta--button-styling--secondary_1wc0z_82",
  "purpur-card-cta--button-styling--secondary-negative": "_purpur-card-cta--button-styling--secondary-negative_1wc0z_93",
  "purpur-card-cta--button-styling--expressive": "_purpur-card-cta--button-styling--expressive_1wc0z_104",
  "purpur-card-cta--button-styling--expressive-negative": "_purpur-card-cta--button-styling--expressive-negative_1wc0z_114",
  "purpur-card-cta--cta-styling": "_purpur-card-cta--cta-styling_1wc0z_126",
  "purpur-card-cta--secondary": "_purpur-card-cta--secondary_1wc0z_131",
  "purpur-card-cta--disabled": "_purpur-card-cta--disabled_1wc0z_131",
  "purpur-card-cta--text": "_purpur-card-cta--text_1wc0z_139"
}, it = _.bind(at), v = "purpur-card-cta", nt = ({
  ["data-testid"]: e = "purpur-card-cta",
  className: n,
  children: a,
  disabled: o = !1,
  iconPosition: p = "right",
  loading: r = !1,
  text: t,
  linkStyling: i = !1,
  ...l
}) => /* @__PURE__ */ u(
  "div",
  {
    className: `${it([
      v,
      n,
      {
        [`${v}--disabled`]: o,
        [`${v}--text`]: !!t,
        [`${v}--cta-styling`]: i,
        [`${v}--button-styling`]: !i,
        [`${v}--button-styling--md`]: !i,
        [`${v}--button-styling--secondary`]: !i,
        [`${v}--button-styling--icon-only`]: !i && !t
      }
    ])} ${v}`,
    "data-testid": e,
    ...l,
    children: r ? /* @__PURE__ */ u(tt, { "data-testid": `${e}-spinner`, size: "xs", disabled: o }) : /* @__PURE__ */ c(Lr, { children: [
      p === "left" && a,
      t,
      p === "right" && a
    ] })
  }
);
function ot(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var gr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var mr;
function pt() {
  return mr || (mr = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function a() {
        for (var r = "", t = 0; t < arguments.length; t++) {
          var i = arguments[t];
          i && (r = p(r, o.call(this, i)));
        }
        return r;
      }
      function o(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return a.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var t = "";
        for (var i in r)
          n.call(r, i) && r[i] && (t = p(t, this && this[i] || i));
        return t;
      }
      function p(r, t) {
        return t ? r ? r + " " + t : r + t : r;
      }
      e.exports ? (a.default = a, e.exports = a) : window.classNames = a;
    })();
  }(gr)), gr.exports;
}
var ut = pt();
const lt = /* @__PURE__ */ ot(ut), st = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, dt = lt.bind(st), vr = "purpur-icon", ct = "md", _t = (e) => e.filter((n) => Object.keys(n).length >= 1).map((n) => `${n.name}="${n.value}"`).join(" "), ft = ({ content: e = "", title: n } = {}) => {
  const a = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    n ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], o = n ? `<title>${n}</title>` : "";
  return `<svg ${_t(a)}>${o}${e}</svg>`;
}, ht = (e) => e.replace(/<(\/?)svg([^>]*)>/g, "").trim(), Gr = ({
  ["data-testid"]: e,
  svg: n,
  allyTitle: a,
  className: o,
  size: p = ct,
  ...r
}) => {
  const t = ft({
    content: ht(n.svg),
    title: a
  }), i = dt(o, vr, `${vr}--${p}`);
  return /* @__PURE__ */ u(
    "span",
    {
      className: i,
      "data-testid": e,
      dangerouslySetInnerHTML: { __html: t },
      ...r
    }
  );
};
Gr.displayName = "Icon";
const gt = {
  name: "checkmark",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M21.06 3.795a.9.9 0 0 1 .145 1.264l-11.5 14.5a.9.9 0 0 1-1.341.077l-6-6a.9.9 0 0 1 1.272-1.272l5.286 5.286L19.795 3.94a.9.9 0 0 1 1.264-.145Z" clip-rule="evenodd"/></svg>',
  keywords: ["checkmark"],
  category: "utility"
}, Zr = (e) => /* @__PURE__ */ u(Gr, { ...e, svg: gt });
Zr.displayName = "IconCheckmark";
function mt(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var yr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var wr;
function vt() {
  return wr || (wr = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function a() {
        for (var r = "", t = 0; t < arguments.length; t++) {
          var i = arguments[t];
          i && (r = p(r, o(i)));
        }
        return r;
      }
      function o(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return a.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var t = "";
        for (var i in r)
          n.call(r, i) && r[i] && (t = p(t, i));
        return t;
      }
      function p(r, t) {
        return t ? r ? r + " " + t : r + t : r;
      }
      e.exports ? (a.default = a, e.exports = a) : window.classNames = a;
    })();
  }(yr)), yr.exports;
}
var yt = vt();
const wt = /* @__PURE__ */ mt(yt), F = {
  "purpur-paragraph": "_purpur-paragraph_1rh57_1",
  "purpur-paragraph--disabled": "_purpur-paragraph--disabled_1rh57_7",
  "purpur-paragraph--hyphens": "_purpur-paragraph--hyphens_1rh57_10",
  "purpur-paragraph--negative": "_purpur-paragraph--negative_1rh57_13",
  "purpur-paragraph--paragraph-100": "_purpur-paragraph--paragraph-100_1rh57_16",
  "purpur-paragraph--paragraph-100-medium": "_purpur-paragraph--paragraph-100-medium_1rh57_22",
  "purpur-paragraph--paragraph-100-bold": "_purpur-paragraph--paragraph-100-bold_1rh57_29",
  "purpur-paragraph--paragraph-200": "_purpur-paragraph--paragraph-200_1rh57_36",
  "purpur-paragraph--preamble-100": "_purpur-paragraph--preamble-100_1rh57_42",
  "purpur-paragraph--preamble-200": "_purpur-paragraph--preamble-200_1rh57_48",
  "purpur-paragraph--additional-100": "_purpur-paragraph--additional-100_1rh57_54",
  "purpur-paragraph--additional-100-medium": "_purpur-paragraph--additional-100-medium_1rh57_60",
  "purpur-paragraph--overline-100": "_purpur-paragraph--overline-100_1rh57_67",
  "purpur-paragraph--overline-200": "_purpur-paragraph--overline-200_1rh57_75"
}, xt = {
  PARAGRAPH100: "paragraph-100"
}, B = "purpur-paragraph", Q = ({
  ["data-testid"]: e,
  children: n,
  className: a,
  disabled: o,
  enableHyphenation: p = !1,
  negative: r = !1,
  variant: t = xt.PARAGRAPH100,
  ...i
}) => {
  const l = wt([
    a,
    F[B],
    F[`${B}--${t}`],
    {
      [F[`${B}--hyphens`]]: p,
      [F[`${B}--disabled`]]: o,
      [F[`${B}--negative`]]: r
    }
  ]);
  return /* @__PURE__ */ u("p", { ...i, className: l, "data-testid": e, children: n });
};
Q.displayName = "Paragraph";
const bt = {
  "purpur-card-feature-list": "_purpur-card-feature-list_198s4_1",
  "purpur-card-feature-list__list-item": "_purpur-card-feature-list__list-item_198s4_7"
}, xr = _.bind(bt), br = "purpur-card-feature-list", Ct = ({
  ["data-testid"]: e = "purpur-card-feature-list",
  listItems: n
}) => n && n.length > 0 ? /* @__PURE__ */ u("ul", { className: xr(br), "data-testid": e, children: n.map((a) => /* @__PURE__ */ c(
  "li",
  {
    className: xr(`${br}__list-item`),
    "data-testid": `${e}-item`,
    children: [
      /* @__PURE__ */ u(Zr, { size: "xs" }),
      /* @__PURE__ */ u(Q, { children: a })
    ]
  },
  a
)) }) : null;
function St(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Cr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Sr;
function $t() {
  return Sr || (Sr = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function a() {
        for (var r = "", t = 0; t < arguments.length; t++) {
          var i = arguments[t];
          i && (r = p(r, o(i)));
        }
        return r;
      }
      function o(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return a.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var t = "";
        for (var i in r)
          n.call(r, i) && r[i] && (t = p(t, i));
        return t;
      }
      function p(r, t) {
        return t ? r ? r + " " + t : r + t : r;
      }
      e.exports ? (a.default = a, e.exports = a) : window.classNames = a;
    })();
  }(Cr)), Cr.exports;
}
var At = $t();
const Ft = /* @__PURE__ */ St(At), G = {
  "purpur-heading": "_purpur-heading_k9fhq_1",
  "purpur-heading--hyphens": "_purpur-heading--hyphens_k9fhq_8",
  "purpur-heading--negative": "_purpur-heading--negative_k9fhq_11",
  "purpur-heading--subsection-100": "_purpur-heading--subsection-100_k9fhq_14",
  "purpur-heading--title-100": "_purpur-heading--title-100_k9fhq_20",
  "purpur-heading--title-200": "_purpur-heading--title-200_k9fhq_26",
  "purpur-heading--title-300": "_purpur-heading--title-300_k9fhq_32",
  "purpur-heading--title-400": "_purpur-heading--title-400_k9fhq_38",
  "purpur-heading--title-500": "_purpur-heading--title-500_k9fhq_44",
  "purpur-heading--title-600": "_purpur-heading--title-600_k9fhq_50",
  "purpur-heading--title-700": "_purpur-heading--title-700_k9fhq_56",
  "purpur-heading--display-25": "_purpur-heading--display-25_k9fhq_62",
  "purpur-heading--display-50": "_purpur-heading--display-50_k9fhq_68",
  "purpur-heading--display-100": "_purpur-heading--display-100_k9fhq_74",
  "purpur-heading--display-200": "_purpur-heading--display-200_k9fhq_80"
}, Bt = {
  TITLE100: "title-100"
}, Z = "purpur-heading", Er = ({
  children: e,
  className: n = "",
  enableHyphenation: a = !1,
  negative: o = !1,
  tag: p,
  variant: r = Bt.TITLE100,
  ...t
}) => {
  const i = p, l = Ft([
    n,
    G[Z],
    G[`${Z}--${r}`],
    {
      [G[`${Z}--hyphens`]]: a,
      [G[`${Z}--negative`]]: o
    }
  ]);
  return /* @__PURE__ */ u(i, { className: l, ...t, children: e });
};
Er.displayName = "Heading";
const kt = {
  "purpur-card-heading": "_purpur-card-heading_j3j6u_1",
  "purpur-card-heading__header": "_purpur-card-heading__header_j3j6u_6",
  "purpur-card-heading__heading": "_purpur-card-heading__heading_j3j6u_11",
  "purpur-card-heading__icon": "_purpur-card-heading__icon_j3j6u_14"
}, Ot = {
  "purpur-card-trigger-item--link": "_purpur-card-trigger-item--link_t6ena_1",
  "purpur-card-trigger-item--button": "_purpur-card-trigger-item--button_t6ena_5",
  "purpur-card-trigger-item--disabled": "_purpur-card-trigger-item--disabled_t6ena_18",
  "purpur-card-trigger-item": "_purpur-card-trigger-item_t6ena_1"
}, $r = _.bind(Ot), w = "purpur-card-trigger-item", Nt = ({
  ["data-testid"]: e = "purpur-card-trigger-item",
  ["aria-label"]: n,
  disabled: a = !1,
  href: o,
  onClick: p,
  children: r,
  linkElement: t = "a"
}) => {
  const i = (x) => {
    a ? x.preventDefault() : p && p();
  }, l = `${w} ${a ? `${w}--disabled` : ""}`;
  return o ? /* @__PURE__ */ u(
    t,
    {
      "aria-disabled": a,
      "aria-label": n,
      className: `${$r([
        w,
        `${w}--link`,
        {
          [`${w}--disabled`]: a
        }
      ])} ${l}`,
      "data-testid": e,
      href: a ? void 0 : o,
      tabIndex: a ? 0 : void 0,
      onClick: i,
      children: r
    }
  ) : /* @__PURE__ */ u(
    "button",
    {
      "aria-disabled": a,
      "aria-label": n,
      className: `${$r([
        w,
        `${w}--button`,
        {
          [`${w}--disabled`]: a
        }
      ])} ${l}`,
      "data-testid": e,
      type: "button",
      onClick: i,
      children: r
    }
  );
}, E = _.bind(kt), b = "purpur-card-heading", jt = ({
  ["data-testid"]: e = "purpur-card-heading",
  ["aria-label"]: n,
  title: a,
  icon: o,
  children: p,
  titleTag: r = "h2",
  enableHyphenation: t,
  onClick: i = void 0,
  href: l = void 0,
  disabled: x = !1,
  linkElement: I = "a",
  variant: q = "title-100",
  ...R
}) => {
  const N = E(b, {
    [`${b}--is-interactive`]: i || l,
    [`${b}--disabled`]: x
  });
  return /* @__PURE__ */ c("div", { className: N, "data-testid": e, children: [
    /* @__PURE__ */ c("div", { className: E(`${b}__header`), children: [
      o && /* @__PURE__ */ u("div", { className: E(`${b}__icon`), children: o }),
      /* @__PURE__ */ u(
        Er,
        {
          tag: r,
          className: E(`${b}__heading`),
          variant: q,
          enableHyphenation: t,
          ...R,
          children: i || l ? /* @__PURE__ */ u(
            Nt,
            {
              "aria-label": n,
              disabled: x,
              href: l,
              onClick: i,
              linkElement: I,
              children: a
            }
          ) : a
        }
      )
    ] }),
    p
  ] });
}, Mt = {
  "purpur-card-media": "_purpur-card-media_udc1o_1"
}, Gt = _.bind(Mt), Zt = "purpur-card-media", Et = ({
  ["data-testid"]: e = "purpur-card-media",
  className: n,
  children: a,
  ...o
}) => /* @__PURE__ */ u("div", { ...o, className: Gt([Zt, n]), "data-testid": e, children: a }), Ut = {
  "purpur-card-media-layout": "_purpur-card-media-layout_1yfvb_1"
}, zt = _.bind(Ut), It = "purpur-card-media-layout", qt = ({
  ["data-testid"]: e = "purpur-card-media-layout",
  className: n,
  children: a,
  ...o
}) => /* @__PURE__ */ u("div", { ...o, className: zt([It, n]), "data-testid": e, children: a }), Rt = {
  "purpur-card-overline": "_purpur-card-overline_qhfj0_1"
}, Lt = _.bind(Rt), Pt = "purpur-card-overline", Dt = ({
  ["data-testid"]: e = "purpur-card-overline",
  overline: n
}) => n ? /* @__PURE__ */ u(Q, { variant: "overline-100", className: Lt(Pt), "data-testid": e, children: n }) : null, Ht = {
  "purpur-card-root": "_purpur-card-root_eupww_1",
  "purpur-card-root--primary": "_purpur-card-root--primary_eupww_7",
  "purpur-card-root--secondary": "_purpur-card-root--secondary_eupww_10",
  "purpur-card-root--full-height": "_purpur-card-root--full-height_eupww_13"
}, Tt = _.bind(Ht), W = "purpur-card-root", Ur = Nr(
  ({
    ["data-testid"]: e = "purpur-card-root",
    children: n,
    className: a,
    fullHeight: o = !0,
    variant: p,
    ...r
  }, t) => {
    const i = Tt([
      W,
      a,
      {
        [`${W}--${p}`]: p,
        [`${W}--full-height`]: o
      }
    ]);
    return /* @__PURE__ */ u("div", { className: i, "data-testid": e, ref: t, ...r, children: n });
  }
);
Ur.displayName = "CardRoot";
const K = _.bind(he), Y = "purpur-card", f = ({ children: e, className: n, ...a }) => {
  const o = K([Y, n]);
  return /* @__PURE__ */ u(
    "div",
    {
      className: K(`${Y}__container`, {
        [`${Y}__container--full-height`]: a.fullHeight
      }),
      children: /* @__PURE__ */ u(Ur, { className: K(o), ...a, children: e })
    }
  );
};
f.Badge = Le;
f.Content = Te;
f.ContentContainer = Ke;
f.Cta = nt;
f.FeatureList = Ct;
f.Overline = Dt;
f.Heading = jt;
f.Media = Et;
f.MediaLayout = qt;
f.displayName = "Card";
function Vt(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ar = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Fr;
function Wt() {
  return Fr || (Fr = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function a() {
        for (var r = "", t = 0; t < arguments.length; t++) {
          var i = arguments[t];
          i && (r = p(r, o(i)));
        }
        return r;
      }
      function o(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return a.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var t = "";
        for (var i in r)
          n.call(r, i) && r[i] && (t = p(t, i));
        return t;
      }
      function p(r, t) {
        return t ? r ? r + " " + t : r + t : r;
      }
      e.exports ? (a.default = a, e.exports = a) : window.classNames = a;
    })();
  }(Ar)), Ar.exports;
}
var Kt = Wt();
const Yt = /* @__PURE__ */ Vt(Kt), U = {
  "purpur-heading": "_purpur-heading_k9fhq_1",
  "purpur-heading--hyphens": "_purpur-heading--hyphens_k9fhq_8",
  "purpur-heading--negative": "_purpur-heading--negative_k9fhq_11",
  "purpur-heading--subsection-100": "_purpur-heading--subsection-100_k9fhq_14",
  "purpur-heading--title-100": "_purpur-heading--title-100_k9fhq_20",
  "purpur-heading--title-200": "_purpur-heading--title-200_k9fhq_26",
  "purpur-heading--title-300": "_purpur-heading--title-300_k9fhq_32",
  "purpur-heading--title-400": "_purpur-heading--title-400_k9fhq_38",
  "purpur-heading--title-500": "_purpur-heading--title-500_k9fhq_44",
  "purpur-heading--title-600": "_purpur-heading--title-600_k9fhq_50",
  "purpur-heading--title-700": "_purpur-heading--title-700_k9fhq_56",
  "purpur-heading--display-25": "_purpur-heading--display-25_k9fhq_62",
  "purpur-heading--display-50": "_purpur-heading--display-50_k9fhq_68",
  "purpur-heading--display-100": "_purpur-heading--display-100_k9fhq_74",
  "purpur-heading--display-200": "_purpur-heading--display-200_k9fhq_80"
}, Jt = {
  TITLE100: "title-100"
}, z = "purpur-heading", zr = ({
  children: e,
  className: n = "",
  enableHyphenation: a = !1,
  negative: o = !1,
  tag: p,
  variant: r = Jt.TITLE100,
  ...t
}) => {
  const i = p, l = Yt([
    n,
    U[z],
    U[`${z}--${r}`],
    {
      [U[`${z}--hyphens`]]: a,
      [U[`${z}--negative`]]: o
    }
  ]);
  return /* @__PURE__ */ u(i, { className: l, ...t, children: e });
};
zr.displayName = "Heading";
function Qt(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Br = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var kr;
function Xt() {
  return kr || (kr = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function a() {
        for (var r = "", t = 0; t < arguments.length; t++) {
          var i = arguments[t];
          i && (r = p(r, o(i)));
        }
        return r;
      }
      function o(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return a.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var t = "";
        for (var i in r)
          n.call(r, i) && r[i] && (t = p(t, i));
        return t;
      }
      function p(r, t) {
        return t ? r ? r + " " + t : r + t : r;
      }
      e.exports ? (a.default = a, e.exports = a) : window.classNames = a;
    })();
  }(Br)), Br.exports;
}
var ra = Xt();
const ea = /* @__PURE__ */ Qt(ra), k = {
  "purpur-paragraph": "_purpur-paragraph_1rh57_1",
  "purpur-paragraph--disabled": "_purpur-paragraph--disabled_1rh57_7",
  "purpur-paragraph--hyphens": "_purpur-paragraph--hyphens_1rh57_10",
  "purpur-paragraph--negative": "_purpur-paragraph--negative_1rh57_13",
  "purpur-paragraph--paragraph-100": "_purpur-paragraph--paragraph-100_1rh57_16",
  "purpur-paragraph--paragraph-100-medium": "_purpur-paragraph--paragraph-100-medium_1rh57_22",
  "purpur-paragraph--paragraph-100-bold": "_purpur-paragraph--paragraph-100-bold_1rh57_29",
  "purpur-paragraph--paragraph-200": "_purpur-paragraph--paragraph-200_1rh57_36",
  "purpur-paragraph--preamble-100": "_purpur-paragraph--preamble-100_1rh57_42",
  "purpur-paragraph--preamble-200": "_purpur-paragraph--preamble-200_1rh57_48",
  "purpur-paragraph--additional-100": "_purpur-paragraph--additional-100_1rh57_54",
  "purpur-paragraph--additional-100-medium": "_purpur-paragraph--additional-100-medium_1rh57_60",
  "purpur-paragraph--overline-100": "_purpur-paragraph--overline-100_1rh57_67",
  "purpur-paragraph--overline-200": "_purpur-paragraph--overline-200_1rh57_75"
}, ta = {
  PARAGRAPH100: "paragraph-100"
}, O = "purpur-paragraph", Ir = ({
  ["data-testid"]: e,
  children: n,
  className: a,
  disabled: o,
  enableHyphenation: p = !1,
  negative: r = !1,
  variant: t = ta.PARAGRAPH100,
  ...i
}) => {
  const l = ea([
    a,
    k[O],
    k[`${O}--${t}`],
    {
      [k[`${O}--hyphens`]]: p,
      [k[`${O}--disabled`]]: o,
      [k[`${O}--negative`]]: r
    }
  ]);
  return /* @__PURE__ */ u("p", { ...i, className: l, "data-testid": e, children: n });
};
Ir.displayName = "Paragraph";
function aa(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var J = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Or;
function ia() {
  return Or || (Or = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function a() {
        for (var r = "", t = 0; t < arguments.length; t++) {
          var i = arguments[t];
          i && (r = p(r, o.call(this, i)));
        }
        return r;
      }
      function o(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return a.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var t = "";
        for (var i in r)
          n.call(r, i) && r[i] && (t = p(t, this && this[i] || i));
        return t;
      }
      function p(r, t) {
        return t ? r ? r + " " + t : r + t : r;
      }
      e.exports ? (a.default = a, e.exports = a) : window.classNames = a;
    })();
  }(J)), J.exports;
}
var na = ia();
const oa = /* @__PURE__ */ aa(na), pa = {
  "purpur-promotion-card": "_purpur-promotion-card_1ufmj_1",
  "purpur-promotion-card--without-image": "_purpur-promotion-card--without-image_1ufmj_8",
  "purpur-promotion-card__content": "_purpur-promotion-card__content_1ufmj_8",
  "purpur-promotion-card--with-image": "_purpur-promotion-card--with-image_1ufmj_33",
  "purpur-promotion-card__card": "_purpur-promotion-card__card_1ufmj_45",
  "purpur-promotion-card__image-gradient": "_purpur-promotion-card__image-gradient_1ufmj_48",
  "purpur-promotion-card__actions": "_purpur-promotion-card__actions_1ufmj_64",
  "purpur-promotion-card__content--without-image": "_purpur-promotion-card__content--without-image_1ufmj_80",
  "purpur-promotion-card__main-content": "_purpur-promotion-card__main-content_1ufmj_83",
  "purpur-promotion-card__heading": "_purpur-promotion-card__heading_1ufmj_88",
  "purpur-promotion-card__content--with-image": "_purpur-promotion-card__content--with-image_1ufmj_93",
  "purpur-promotion-card__badge-wrapper": "_purpur-promotion-card__badge-wrapper_1ufmj_104",
  "purpur-promotion-card__body": "_purpur-promotion-card__body_1ufmj_108",
  "purpur-promotion-card__main-content--space-between": "_purpur-promotion-card__main-content--space-between_1ufmj_119",
  "purpur-promotion-card__main-content--flex-end": "_purpur-promotion-card__main-content--flex-end_1ufmj_122",
  "purpur-promotion-card__child-content": "_purpur-promotion-card__child-content_1ufmj_142",
  "purpur-promotion-card__additional-text": "_purpur-promotion-card__additional-text_1ufmj_145",
  "purpur-promotion-card__image-wrapper": "_purpur-promotion-card__image-wrapper_1ufmj_148",
  "purpur-promotion-card__image-wrapper--decorative": "_purpur-promotion-card__image-wrapper--decorative_1ufmj_151",
  "purpur-promotion-card__image-wrapper--product": "_purpur-promotion-card__image-wrapper--product_1ufmj_152"
}, ha = ["primary", "secondary", "quaternary"], ua = {
  primary: "var(--purpur-color-background-tone-on-tone-primary)",
  secondary: "var(--purpur-color-background-tone-on-tone-secondary)",
  quaternary: "var(--purpur-color-background-tone-on-tone-quaternary)"
}, la = {
  primary: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="2000" height="1125" viewBox="0 0 2000 1125" fill="none"><g clip-path="url(%23clip0_20_36)"><rect width="2000" height="1125" fill="url(%23paint0_linear_20_36)"/><g filter="url(%23filter0_d_20_36)"><path d="M480.784 -336.718L483.018 -338.805C2086.53 -1722.59 2447.86 284.242 2322.13 1089.91C2196.4 1895.57 1114.05 1663.85 598.008 1169.98C188.829 778.383 94.9071 433.168 84.5809 306.459C63.8953 52.6354 248.918 -120.167 480.784 -336.718Z" fill="%23F5E5FF"/></g><g filter="url(%23filter1_d_20_36)"><path d="M478.235 -337.757L480.469 -339.844C2083.98 -1723.63 2445.31 283.203 2319.58 1088.87C2193.85 1894.53 1111.5 1662.81 595.459 1168.95C186.28 777.344 91.9004 426.514 82.0318 305.42C61.3463 51.5961 246.369 -121.206 478.235 -337.757Z" fill="url(%23paint1_linear_20_36)"/></g><path d="M478.351 -359.804L480.585 -361.891C2084.1 -1745.68 2445.43 261.156 2319.7 1066.82C2193.96 1872.48 1111.61 1640.77 595.575 1146.9C186.396 755.297 91.9029 403.076 82.1476 283.373C61.4621 29.5494 246.485 -143.253 478.351 -359.804Z" fill="url(%23paint2_linear_20_36)" stroke="url(%23paint3_linear_20_36)" stroke-width="0.488281"/><g filter="url(%23filter2_d_20_36)"><path d="M895.095 -81.1636L897.087 -83.483C2339.2 -1634.76 2918.4 320.353 2881.77 1134.95C2845.14 1949.54 1743.91 1837.9 1176.83 1403.6C727.176 1059.23 595.967 726.393 571.809 601.58C523.415 351.555 688.373 159.507 895.095 -81.1636Z" fill="%23F5E5FF"/></g><g filter="url(%23filter3_d_20_36)"><path d="M892.877 -81.1463L894.869 -83.4656C2336.98 -1634.74 2916.18 320.371 2879.55 1134.96C2842.92 1949.56 1741.69 1837.92 1174.61 1403.62C724.958 1059.24 592.678 720.879 569.59 601.597C521.196 351.573 686.155 159.524 892.877 -81.1463Z" fill="url(%23paint4_linear_20_36)"/></g><path d="M899.248 -92.3297L901.24 -94.6491C2343.35 -1645.93 2922.56 309.187 2885.93 1123.78C2849.3 1938.37 1748.06 1826.74 1180.98 1392.43C731.329 1048.06 598.784 708.325 575.961 590.414C527.568 340.389 692.526 148.341 899.248 -92.3297Z" fill="url(%23paint5_linear_20_36)" stroke="url(%23paint6_linear_20_36)" stroke-width="0.488281"/></g><defs><filter id="filter0_d_20_36" x="67" y="-812.852" width="2294.05" height="2463.76" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="16"/><feGaussianBlur stdDeviation="8"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0.0588235 0 0 0 0 0 0 0 0 0 0.129412 0 0 0 0.95 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_20_36"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_20_36" result="shape"/></filter><filter id="filter1_d_20_36" x="-69.5491" y="-947.891" width="2562.05" height="2731.76" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="16"/><feGaussianBlur stdDeviation="75"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0.0588235 0 0 0 0 0 0 0 0 0 0.129412 0 0 0 0.6 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_20_36"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_20_36" result="shape"/></filter><filter id="filter2_d_20_36" x="547.307" y="-664.639" width="2352.09" height="2436.12" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="16"/><feGaussianBlur stdDeviation="8"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0.0588235 0 0 0 0 0 0 0 0 0 0.129412 0 0 0 0.95 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_20_36"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_20_36" result="shape"/></filter><filter id="filter3_d_20_36" x="361.088" y="-864.621" width="2720.09" height="2804.12" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset/><feGaussianBlur stdDeviation="100"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0.0588235 0 0 0 0 0 0 0 0 0 0.129412 0 0 0 0.65 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_20_36"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_20_36" result="shape"/></filter><linearGradient id="paint0_linear_20_36" x1="48.3398" y1="4.80196e-07" x2="58.1053" y2="1125" gradientUnits="userSpaceOnUse"><stop stop-color="%23340249"/><stop offset="0.576094" stop-color="%23300244"/><stop offset="1" stop-color="%232D0241"/></linearGradient><linearGradient id="paint1_linear_20_36" x1="80.5668" y1="233.643" x2="606.544" y2="1094.45" gradientUnits="userSpaceOnUse"><stop stop-color="%2359006E"/><stop offset="0.265" stop-color="%2347005E"/><stop offset="0.385" stop-color="%2339004E"/><stop offset="0.720829" stop-color="%23210034"/><stop offset="1" stop-color="%23150026"/></linearGradient><linearGradient id="paint2_linear_20_36" x1="138.672" y1="41.2598" x2="702.488" y2="1106.9" gradientUnits="userSpaceOnUse"><stop stop-color="%2335004A"/><stop offset="0.19574" stop-color="%23320046"/><stop offset="1" stop-color="%2328003B"/></linearGradient><linearGradient id="paint3_linear_20_36" x1="133.5" y1="60.5" x2="546" y2="1048" gradientUnits="userSpaceOnUse"><stop stop-color="%23AC3CAF"/><stop offset="0.506509" stop-color="%234A006B"/><stop offset="1" stop-color="%232B003F"/></linearGradient><linearGradient id="paint4_linear_20_36" x1="560.263" y1="530.414" x2="910.742" y2="1118.56" gradientUnits="userSpaceOnUse"><stop stop-color="%234F0065"/><stop offset="0.340552" stop-color="%2339004E"/><stop offset="0.616738" stop-color="%23230036"/><stop offset="1" stop-color="%23150026"/></linearGradient><linearGradient id="paint5_linear_20_36" x1="781.494" y1="72.6501" x2="2048.67" y2="1066.94" gradientUnits="userSpaceOnUse"><stop stop-color="%232F0044"/><stop offset="0.51248" stop-color="%2328003B"/><stop offset="1" stop-color="%23240037"/></linearGradient><linearGradient id="paint6_linear_20_36" x1="820.5" y1="32.5001" x2="906.975" y2="1110.35" gradientUnits="userSpaceOnUse"><stop stop-color="%238A1994"/><stop offset="0.425" stop-color="%237A1387"/><stop offset="1" stop-color="%2327003A"/></linearGradient><clipPath id="clip0_20_36"><rect width="2000" height="1125" fill="white"/></clipPath></defs></svg>')`,
  secondary: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="2000" height="1125" viewBox="0 0 2000 1125" fill="none"><g clip-path="url(%23clip0_13_40)"><rect width="2000" height="1125" fill="url(%23paint0_linear_13_40)"/><rect x="-226.435" y="213.022" width="435.932" height="216.966" transform="rotate(-66.9915 -226.435 213.022)" fill="url(%23paint1_linear_13_40)"/><g filter="url(%23filter0_d_13_40)"><path d="M480.784 -336.718L483.018 -338.805C2086.53 -1722.59 2447.86 284.242 2322.13 1089.91C2196.4 1895.57 1114.05 1663.85 598.008 1169.98C188.829 778.383 94.9071 433.168 84.5809 306.459C63.8953 52.6354 248.918 -120.167 480.784 -336.718Z" fill="%23F5E5FF"/></g><g filter="url(%23filter1_d_13_40)"><path d="M478.235 -337.757L480.469 -339.844C2083.98 -1723.63 2445.31 283.203 2319.58 1088.87C2193.85 1894.53 1111.5 1662.81 595.459 1168.95C186.279 777.344 91.9002 426.514 82.0316 305.42C61.346 51.5961 246.369 -121.206 478.235 -337.757Z" fill="url(%23paint2_linear_13_40)"/></g><path d="M478.35 -359.804L480.585 -361.891C2084.1 -1745.68 2445.43 261.156 2319.7 1066.82C2193.96 1872.48 1111.61 1640.77 595.575 1146.9C186.395 755.297 91.9025 403.076 82.1473 283.373C61.4618 29.5494 246.484 -143.253 478.35 -359.804Z" fill="url(%23paint3_linear_13_40)" stroke="url(%23paint4_linear_13_40)" stroke-width="0.488281"/><g filter="url(%23filter2_d_13_40)"><path d="M895.095 -81.1636L897.087 -83.483C2339.2 -1634.76 2918.4 320.353 2881.77 1134.95C2845.14 1949.54 1743.91 1837.9 1176.83 1403.6C727.176 1059.23 595.967 726.393 571.809 601.58C523.415 351.555 688.373 159.507 895.095 -81.1636Z" fill="%23F5E5FF"/></g><g filter="url(%23filter3_d_13_40)"><path d="M892.877 -81.1463L894.869 -83.4656C2336.98 -1634.74 2916.18 320.371 2879.55 1134.96C2842.92 1949.56 1741.69 1837.92 1174.61 1403.62C724.958 1059.24 592.678 720.879 569.59 601.597C521.196 351.573 686.155 159.524 892.877 -81.1463Z" fill="url(%23paint5_linear_13_40)"/></g><path d="M899.248 -92.3297L901.24 -94.6491C2343.35 -1645.93 2922.56 309.187 2885.93 1123.78C2849.3 1938.37 1748.06 1826.74 1180.98 1392.43C731.329 1048.06 598.784 708.325 575.961 590.414C527.568 340.389 692.526 148.341 899.248 -92.3297Z" fill="url(%23paint6_linear_13_40)" stroke="url(%23paint7_linear_13_40)" stroke-width="0.488281"/></g><defs><filter id="filter0_d_13_40" x="67" y="-812.852" width="2294.05" height="2463.76" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="16"/><feGaussianBlur stdDeviation="8"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0.605849 0 0 0 0 0.52 0 0 0 0 0.65 0 0 0 0.95 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_13_40"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_13_40" result="shape"/></filter><filter id="filter1_d_13_40" x="20.4507" y="-841.891" width="2382.05" height="2551.76" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="32"/><feGaussianBlur stdDeviation="30"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0.628679 0 0 0 0 0.49 0 0 0 0 0.7 0 0 0 0.5 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_13_40"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_13_40" result="shape"/></filter><filter id="filter2_d_13_40" x="547.307" y="-664.639" width="2352.09" height="2436.12" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="16"/><feGaussianBlur stdDeviation="8"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0.594811 0 0 0 0 0.4875 0 0 0 0 0.65 0 0 0 0.95 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_13_40"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_13_40" result="shape"/></filter><filter id="filter3_d_13_40" x="381.088" y="-820.621" width="2680.09" height="2764.12" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="24"/><feGaussianBlur stdDeviation="90"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0.61425 0 0 0 0 0.455 0 0 0 0 0.7 0 0 0 0.62 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_13_40"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_13_40" result="shape"/></filter><linearGradient id="paint0_linear_13_40" x1="48.3398" y1="4.80196e-07" x2="58.1053" y2="1125" gradientUnits="userSpaceOnUse"><stop stop-color="%23F6E6FF"/><stop offset="0.465" stop-color="%23F5E2FF"/><stop offset="1" stop-color="%23F2DCFE"/></linearGradient><linearGradient id="paint1_linear_13_40" x1="-8.46836" y1="213.022" x2="-8.46836" y2="429.988" gradientUnits="userSpaceOnUse"><stop stop-color="white"/><stop offset="0.0001" stop-color="%23FFFEFD"/><stop offset="1" stop-color="white" stop-opacity="0"/></linearGradient><linearGradient id="paint2_linear_13_40" x1="80.5666" y1="233.643" x2="606.544" y2="1094.45" gradientUnits="userSpaceOnUse"><stop stop-color="white"/><stop offset="0.265" stop-color="white"/><stop offset="0.385" stop-color="%23F7EAFF"/><stop offset="0.720829" stop-color="%23D3BCDF"/><stop offset="1" stop-color="%23AA91B7"/></linearGradient><linearGradient id="paint3_linear_13_40" x1="138.672" y1="41.2598" x2="702.487" y2="1106.9" gradientUnits="userSpaceOnUse"><stop stop-color="%23F7E9FF"/><stop offset="0.19574" stop-color="%23F6E7FF"/><stop offset="1" stop-color="%23EBD5F6"/></linearGradient><linearGradient id="paint4_linear_13_40" x1="163.5" y1="527.148" x2="390.5" y2="902.648" gradientUnits="userSpaceOnUse"><stop stop-color="white"/><stop offset="0.0001" stop-color="white"/><stop offset="1" stop-color="%23F1DBFC"/></linearGradient><linearGradient id="paint5_linear_13_40" x1="560.263" y1="530.414" x2="910.742" y2="1118.56" gradientUnits="userSpaceOnUse"><stop stop-color="white"/><stop offset="0.340552" stop-color="%23F7E9FF"/><stop offset="0.616738" stop-color="%23E1CBED"/><stop offset="1" stop-color="%23AB92B8"/></linearGradient><linearGradient id="paint6_linear_13_40" x1="781.494" y1="72.6501" x2="2048.67" y2="1066.94" gradientUnits="userSpaceOnUse"><stop stop-color="%23F5E3FF"/><stop offset="0.51248" stop-color="%23EBD5F7"/><stop offset="1" stop-color="%23E0C9EB"/></linearGradient><linearGradient id="paint7_linear_13_40" x1="580.804" y1="451.174" x2="906.975" y2="1110.35" gradientUnits="userSpaceOnUse"><stop stop-color="white"/><stop offset="0.0001" stop-color="white"/><stop offset="1" stop-color="%23E5DBD5"/></linearGradient><clipPath id="clip0_13_40"><rect width="2000" height="1125" fill="white"/></clipPath></defs></svg>')`,
  quaternary: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="2000" height="1125" viewBox="0 0 2000 1125" fill="none"><g clip-path="url(%23clip0_16_50)"><rect width="2000" height="1125" fill="url(%23paint0_linear_16_50)"/><rect x="-145.375" y="247.444" width="435.932" height="128.9" transform="rotate(-66.9915 -145.375 247.444)" fill="url(%23paint1_linear_16_50)"/><g filter="url(%23filter0_d_16_50)"><path d="M480.784 -336.718L483.018 -338.805C2086.53 -1722.59 2447.86 284.242 2322.13 1089.91C2196.4 1895.57 1114.05 1663.85 598.008 1169.98C188.829 778.383 94.9071 433.168 84.5809 306.459C63.8953 52.6354 248.918 -120.167 480.784 -336.718Z" fill="%23EFE5DF"/></g><g filter="url(%23filter1_d_16_50)"><path d="M478.235 -337.757L480.469 -339.844C2083.98 -1723.63 2445.31 283.203 2319.58 1088.87C2193.85 1894.53 1111.5 1662.81 595.459 1168.95C186.279 777.344 91.9002 426.514 82.0316 305.42C61.346 51.5961 246.369 -121.206 478.235 -337.757Z" fill="url(%23paint2_linear_16_50)"/></g><path d="M478.35 -359.804L480.585 -361.891C2084.1 -1745.68 2445.43 261.156 2319.7 1066.82C2193.96 1872.48 1111.61 1640.77 595.575 1146.9C186.395 755.297 91.9025 403.076 82.1473 283.373C61.4618 29.5494 246.484 -143.253 478.35 -359.804Z" fill="url(%23paint3_linear_16_50)" stroke="url(%23paint4_linear_16_50)" stroke-width="0.488281"/><g filter="url(%23filter2_d_16_50)"><path d="M895.095 -81.1636L897.087 -83.483C2339.2 -1634.76 2918.4 320.353 2881.77 1134.95C2845.14 1949.54 1743.91 1837.9 1176.83 1403.6C727.176 1059.23 595.967 726.393 571.809 601.58C523.415 351.555 688.373 159.507 895.095 -81.1636Z" fill="%23EFE5DF"/></g><g filter="url(%23filter3_d_16_50)"><path d="M892.877 -81.1463L894.869 -83.4656C2336.98 -1634.74 2916.18 320.371 2879.55 1134.96C2842.92 1949.56 1741.69 1837.92 1174.61 1403.62C724.958 1059.24 592.677 720.879 569.59 601.597C521.196 351.573 686.155 159.524 892.877 -81.1463Z" fill="url(%23paint5_linear_16_50)"/></g><path d="M899.248 -92.3297L901.24 -94.6491C2343.35 -1645.93 2922.56 309.187 2885.93 1123.78C2849.3 1938.37 1748.06 1826.74 1180.98 1392.43C731.329 1048.06 598.784 708.325 575.961 590.414C527.568 340.389 692.526 148.341 899.248 -92.3297Z" fill="url(%23paint6_linear_16_50)" stroke="url(%23paint7_linear_16_50)" stroke-width="0.488281"/></g><defs><filter id="filter0_d_16_50" x="67" y="-812.852" width="2294.05" height="2463.76" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="16"/><feGaussianBlur stdDeviation="8"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0.607843 0 0 0 0 0.568627 0 0 0 0 0.545098 0 0 0 0.9 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_16_50"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_16_50" result="shape"/></filter><filter id="filter1_d_16_50" x="0.450684" y="-861.891" width="2422.05" height="2591.76" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="32"/><feGaussianBlur stdDeviation="40"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0.607843 0 0 0 0 0.568627 0 0 0 0 0.545098 0 0 0 0.5 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_16_50"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_16_50" result="shape"/></filter><filter id="filter2_d_16_50" x="547.307" y="-664.639" width="2352.09" height="2436.12" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="16"/><feGaussianBlur stdDeviation="8"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0.607843 0 0 0 0 0.568627 0 0 0 0 0.545098 0 0 0 0.9 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_16_50"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_16_50" result="shape"/></filter><filter id="filter3_d_16_50" x="381.088" y="-844.621" width="2680.09" height="2764.12" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset/><feGaussianBlur stdDeviation="90"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0.607843 0 0 0 0 0.568627 0 0 0 0 0.545098 0 0 0 0.55 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_16_50"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_16_50" result="shape"/></filter><linearGradient id="paint0_linear_16_50" x1="48.3398" y1="4.80196e-07" x2="58.1053" y2="1125" gradientUnits="userSpaceOnUse"><stop stop-color="%23FDF3EE"/><stop offset="0.625484" stop-color="%23F8EEE8"/><stop offset="1" stop-color="%23F0E5DF"/><stop offset="1" stop-color="%23F0E5E0"/></linearGradient><linearGradient id="paint1_linear_16_50" x1="72.5912" y1="247.444" x2="72.5912" y2="376.344" gradientUnits="userSpaceOnUse"><stop stop-color="%23FFFEFD"/><stop offset="0.0001" stop-color="%23FFFEFD"/><stop offset="1" stop-color="%23FFFDFD" stop-opacity="0"/></linearGradient><linearGradient id="paint2_linear_16_50" x1="80.5666" y1="233.643" x2="606.544" y2="1094.45" gradientUnits="userSpaceOnUse"><stop stop-color="white"/><stop offset="0.265" stop-color="white"/><stop offset="0.385" stop-color="%23F5ECE6"/><stop offset="0.720829" stop-color="%23CFC4BE"/><stop offset="1" stop-color="%23C9BDB6"/></linearGradient><linearGradient id="paint3_linear_16_50" x1="138.672" y1="41.2598" x2="702.487" y2="1106.9" gradientUnits="userSpaceOnUse"><stop stop-color="%23FFFAF8"/><stop offset="0.19574" stop-color="%23FEF5EF"/><stop offset="1" stop-color="%23E8DED8"/></linearGradient><linearGradient id="paint4_linear_16_50" x1="163.5" y1="527.148" x2="390.5" y2="902.648" gradientUnits="userSpaceOnUse"><stop stop-color="white"/><stop offset="0.0001" stop-color="white"/><stop offset="1" stop-color="%23E5DBD5"/></linearGradient><linearGradient id="paint5_linear_16_50" x1="560.263" y1="530.414" x2="910.742" y2="1118.56" gradientUnits="userSpaceOnUse"><stop stop-color="white"/><stop offset="0.340552" stop-color="%23FCF2EC"/><stop offset="0.616738" stop-color="%23D8CEC8"/><stop offset="1" stop-color="%23ACA19C"/></linearGradient><linearGradient id="paint6_linear_16_50" x1="781.494" y1="72.6501" x2="2048.67" y2="1066.94" gradientUnits="userSpaceOnUse"><stop stop-color="%23F8EEE8"/><stop offset="0.51248" stop-color="%23E8DED8"/><stop offset="1" stop-color="%23DDD3CE"/></linearGradient><linearGradient id="paint7_linear_16_50" x1="580.804" y1="451.174" x2="906.975" y2="1110.35" gradientUnits="userSpaceOnUse"><stop stop-color="white"/><stop offset="0.0001" stop-color="white"/><stop offset="1" stop-color="%23E5DBD5"/></linearGradient><clipPath id="clip0_16_50"><rect width="2000" height="1125" fill="white"/></clipPath></defs></svg>')`
}, sa = {
  primary: "var(--purpur-color-text-tone-on-tone-primary)",
  secondary: "var(--purpur-color-text-tone-on-tone-secondary)",
  quaternary: "var(--purpur-color-text-tone-on-tone-tertiary)"
}, d = oa.bind(pa), s = "purpur-promotion-card", da = ({
  ["data-testid"]: e,
  variant: n = "primary",
  badgeText: a,
  badgeIcon: o,
  title: p,
  titleTag: r = "h2",
  titleVariant: t = "title-300",
  enableTitleHyphenation: i = !1,
  className: l,
  actions: x,
  children: I,
  style: q,
  alignment: R = "space-between",
  additionalText: N,
  ...h
}, qr) => {
  let j = h, y, M;
  if ("decorativeImage" in h) {
    const { hasGradient: C, decorativeImage: S, ...L } = h;
    y = S, M = C, j = L;
  } else if ("productImage" in h) {
    const { hasGradient: C, productImage: S, ...L } = h;
    y = S, M = C, j = L;
  } else if ("hasGradient" in h) {
    const { hasGradient: C, ...S } = h;
    M = C, j = S;
  }
  const Rr = {
    "--promotion-card-background": ua[n],
    "--promotion-card-color": sa[n],
    "--promotion-card-background-image": la[n]
  };
  return /* @__PURE__ */ u(f, { ref: qr, className: d(`${s}__card`), fullHeight: !0, children: /* @__PURE__ */ c(
    "div",
    {
      "data-testid": e,
      style: {
        ...Rr,
        ...q
      },
      className: d([
        l,
        s,
        `${s}--${n}`,
        {
          [`${s}--with-image`]: y,
          [`${s}--without-image`]: !y
        }
      ]),
      ...j,
      children: [
        /* @__PURE__ */ c(
          "div",
          {
            className: d([
              `${s}__content`,
              {
                [`${s}__content--with-image`]: y,
                [`${s}__content--without-image`]: !y
              }
            ]),
            children: [
              a && /* @__PURE__ */ u("div", { "data-testid": "badgeWrapper", className: d(`${s}__badge-wrapper`), children: /* @__PURE__ */ c(de, { variant: n === "primary" ? "special" : "attention", showIcon: !1, children: [
                o && o,
                a
              ] }) }),
              /* @__PURE__ */ c(
                "div",
                {
                  className: d(
                    `${s}__main-content`,
                    `${s}__main-content--${R}`
                  ),
                  children: [
                    /* @__PURE__ */ u(
                      zr,
                      {
                        tag: r,
                        variant: t,
                        enableHyphenation: i,
                        className: d(`${s}__heading`),
                        children: p
                      }
                    ),
                    /* @__PURE__ */ c("div", { className: d(`${s}__body`), children: [
                      /* @__PURE__ */ u("div", { className: d(`${s}__child-content`), children: I }),
                      x && /* @__PURE__ */ u("div", { className: d(`${s}__actions`), children: x }),
                      N && /* @__PURE__ */ u(
                        Ir,
                        {
                          negative: !0,
                          variant: "additional-100",
                          className: d(`${s}__additional-text`),
                          children: N
                        }
                      )
                    ] })
                  ]
                }
              )
            ]
          }
        ),
        y && /* @__PURE__ */ c(
          "div",
          {
            className: d([
              `${s}__image-wrapper`,
              {
                [`${s}__image-wrapper--product`]: "productImage" in h,
                [`${s}__image-wrapper--decorative`]: "decorativeImage" in h
              }
            ]),
            children: [
              y,
              M && /* @__PURE__ */ u(
                "div",
                {
                  className: d(`${s}__image-gradient`),
                  "data-testid": "promotion-card-gradient"
                }
              )
            ]
          }
        )
      ]
    }
  ) });
}, ca = Nr(da);
ca.displayName = "PromotionCard";
export {
  ca as PromotionCard,
  ha as promotionCardVariants
};
//# sourceMappingURL=promotion-card.es.js.map
